<!-- Header Bar -->
<div class="header-bar px-4 py-2" role="banner" data-testid="course-player-header-section">
  <div class="flex justify-between items-center">
    <!-- Left side: Navigation -->
    @if (showNavigation) {
      <nav class="flex items-center gap-2" aria-label="Course item navigation">
        <button class="btn btn-ghost btn-sm"
          (click)="onNavigatePrevious.emit()"
          [disabled]="!canGoToPrevious"
          title="Previous Item"
          aria-label="Previous item"
          data-testid="course-player-header-prev-btn">
          <app-icon name="arrow_back" size="sm"></app-icon>
        </button>
        <span class="text-sm text-base-content/70 px-2">
          {{ currentIndex + 1 }} / {{ totalItems }}
        </span>
        <button class="btn btn-ghost btn-sm"
          (click)="onNavigateNext.emit()"
          [disabled]="!canGoToNext"
          title="Next Item"
          aria-label="Next item"
          data-testid="course-player-header-next-btn">
          <app-icon name="arrow_forward" size="sm"></app-icon>
        </button>
      </nav>
    }

    <!-- Center: Title and Mode Info -->
    <div class="flex-1 text-center min-w-0 px-2">
      <h2 class="course-player-header-title text-lg font-semibold"
          [title]="customHeaderContent || title"
          data-testid="course-player-header-title-heading">
        {{ customHeaderContent || title }}
      </h2>
      <!-- Mode indicator for moderators -->
      @if (mode !== 'learner') {
        <div class="text-xs mt-1">
          <span class="badge badge-sm" [class]="getModeDisplayInfo().color" data-testid="course-player-header-mode-badge">
            {{ getModeDisplayInfo().name }}
          </span>
        </div>
      }
    </div>

    <!-- Right side: Actions -->
    <div class="flex items-center gap-2">
      <!-- Timeline Toggle -->
      @if (showTimelineToggle) {
        <button
          class="btn btn-ghost btn-sm"
          (click)="onTimelineToggle.emit()"
          data-testid="course-player-header-timeline-btn"
          [title]="timelineVisible ? 'Hide Timeline' : 'Show Timeline'"
          [attr.aria-label]="timelineVisible ? 'Hide timeline' : 'Show timeline'"
          [attr.aria-expanded]="timelineVisible">
          <app-icon [name]="timelineVisible ? 'menu_open' : 'menu'" size="sm"></app-icon>
        </button>
      }

      <!-- Fullscreen toggle -->
      @if (showFullscreen) {
        <button
          class="btn btn-ghost btn-sm"
          (click)="onFullscreenToggle.emit()"
          title="Toggle Fullscreen"
          data-testid="course-player-header-fullscreen-btn"
          [attr.aria-label]="isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'">
          <app-icon [name]="isFullscreen ? 'fullscreen_exit' : 'fullscreen'" size="sm"></app-icon>
        </button>
      }

      <!-- Close button -->
      @if (showCloseButton) {
        <button
          class="btn btn-ghost btn-sm"
          (click)="onClose.emit()"
          title="Close"
          aria-label="Close player"
          data-testid="course-player-header-close-btn">
          <app-icon name="close" size="sm"></app-icon>
        </button>
      }
    </div>
  </div>
</div>
